/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import { Grid, Typography, Hidden, Paper } from "@material-ui/core";
import React from "react";

const LandingPageSection = styled(
  ({ title, listElement, actionsList, iconElement, className, disabled }) => (
    <Paper className={`${disabled && "disabled"} ${className}`}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={7} container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="h2">{title}</Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" component="span">
              {listElement}
            </Typography>
          </Grid>
          {actionsList}
        </Grid>
        <Hidden xsDown>
          <Grid item xs={5} container justify="center" alignItems="center">
            <Grid item>{iconElement}</Grid>
          </Grid>
        </Hidden>
      </Grid>
    </Paper>
  )
)`
  ${({ theme }) => `
    border: 1px solid ${theme.palette.primary.main};
    padding: ${theme.spacing(4)}px;
    min-width: 540px;

    &.disabled {
      pointer-events: none;
      filter: grayscale(100%);
      opacity: 0.5;
    }

    ${theme.breakpoints.down("xs")} {
      min-width: 100%;
      padding: ${theme.spacing(3)}px ${theme.spacing(2)}px;
    }

    li {
      white-space: nowrap;
    }

    svg {
      opacity: 0.8;
    }
  `}
`;

export default LandingPageSection;
